var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-succeed"},[_c('img',{attrs:{"src":require("@/assets/images/CreatePaperSucceed.png"),"alt":""}}),_c('div',{staticClass:"hint"},[_vm._v("创建成功")]),_c('el-button',{staticClass:"blue-button",on:{"click":_vm.backList}},[_vm._v("返回列表")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }